module.exports = __webpack_public_path__ + "static/media/nn-Arbeidsminne-instruction-WORD.5ec6b6c0.mp3";